<div class="p-6 max-w-md">
  <h2 class="text-xl font-semibold mb-4">{{ 'deleteConfirmation.title' | translate }}</h2>

  <div class="mb-6">
    <p class="text-gray-700 mb-4">{{ 'deleteConfirmation.message' | translate }}</p>

    <div class="flex items-start gap-2 bg-red-50 border border-red-200 rounded-lg p-3">
      <i class="fas fa-exclamation-triangle text-red-600 mt-0.5 flex-shrink-0"></i>
      <p class="text-sm text-red-800">{{ 'deleteConfirmation.warning' | translate }}</p>
    </div>
  </div>

  <div class="flex justify-end gap-3">
    <button ctrStrokedButton type="button" (click)="cancel()">
      {{ 'deleteConfirmation.cancel' | translate }}
    </button>
    <button ctrButton type="button" (click)="confirm()">
      {{ 'deleteConfirmation.confirm' | translate }}
    </button>
  </div>
</div>
